import { EmptystateRunsColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import { useInitialSort } from "ds/components/Table/hooks/useInitialSort";
import TableSimple from "ds/components/TableSimple";
import useAnalytics from "hooks/useAnalytics";
import useTypedContext from "hooks/useTypedContext";

import ModuleVersionPageIntoTitle from "../../components/PageIntoTitle";
import ModuleVersionScrollableWrapper from "../../components/ScrollableWrapper";
import { VersionContext } from "../../Context";
import { MODULE_VERSION_TEST_CASES_TABLE_CELLS } from "./Table/Cells";
import {
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
  MODULE_VERSION_TEST_CASES_TABLE_FILTERS_STORAGE_KEY,
  SORT_CONFIG,
} from "./Table/constants";
import { useSortingModuleVersionTestCases } from "./Table/useSortingModuleVersionTestCases";
import useModuleVersionTestCasesTableStore from "./Table/useTableStore";

const ModuleVersionTestCases = () => {
  const { version } = useTypedContext(VersionContext);
  const trackAnalytics = useAnalytics();

  useInitialSort(INITIAL_SORT_OPTION, INITIAL_SORT_DIRECTION);

  const testCases = useSortingModuleVersionTestCases(version?.runs);

  return (
    <>
      <PageInfoHeaderWrapper>
        <ModuleVersionPageIntoTitle
          title="Test cases"
          tooltip="Special type of runs executed on the module. Infrastructure is created for the test, and after the test finishes, it will be deleted."
        />
        {/** TODO: confirm what to do with the new Rerun button */}
      </PageInfoHeaderWrapper>
      <ModuleVersionScrollableWrapper padding="0">
        {testCases.length === 0 && (
          <EmptyState
            padding="x-large"
            icon={EmptystateRunsColored}
            caption="This module has no test cases"
            fullHeight
          />
        )}
        {testCases.length > 0 && (
          <TableSimple
            data={testCases}
            store={useModuleVersionTestCasesTableStore}
            ariaLabel="Test cases"
            trackAnalytics={trackAnalytics}
            cellPerColumn={MODULE_VERSION_TEST_CASES_TABLE_CELLS}
            filtersStorageKey={MODULE_VERSION_TEST_CASES_TABLE_FILTERS_STORAGE_KEY}
            sortConfig={SORT_CONFIG}
            hasPagination={false}
          />
        )}
      </ModuleVersionScrollableWrapper>
    </>
  );
};

export default ModuleVersionTestCases;
